import React from 'react';
import { AlertTriangle, Clock, User, FileText, UserCircle } from 'lucide-react';

const OverdueTasksTab = ({ tasks, onRecordSelect, loading, error }) => {
    if (loading) {
        return (
            <div className="text-center p-8 bg-white rounded-lg ">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
                <p className="mt-2 text-gray-600">Loading overdue tasks...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center p-8 bg-red-50 text-red-700 rounded-lg shadow-md">
                <p>{error}</p>
            </div>
        );
    }

    if (tasks.length === 0) {
        return (
            <div className="text-center py-8 bg-white rounded-lg shadow-md p-6">
                <p className="text-gray-500">No overdue tasks found.</p>
            </div>
        );
    }

    const formatDate = (dateString) => new Date(dateString).toLocaleDateString();

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                <AlertTriangle className="w-6 h-6 mr-2 text-red-600" />
                Overdue Tasks ({tasks.length})
            </h2>
            <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                {tasks.map(task => (
                    <div key={task.commentId} className="border rounded-lg p-4 bg-red-50 border-red-200">
                         <div className="flex justify-between items-start gap-4">
                            <div className="flex-1">
                                <div className="flex items-center flex-wrap gap-x-4 gap-y-1 mb-2">
                                    <span className="font-bold text-lg text-gray-800">{task.ptName}</span>
                                    <span className="text-sm text-gray-600 flex items-center gap-1 font-semibold text-red-700">
                                        <Clock className="w-4 h-4" />
                                        Was due on {formatDate(task.scheduledDate)} {task.scheduledTime && ` at ${task.scheduledTime}`}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-700 mb-2">{task.text}</p>
                                <div className="flex items-center gap-4 text-xs text-gray-500 mt-2">
                                    <span className="flex items-center gap-1 font-medium"><UserCircle className="w-4 h-4" />Assigned to: {task.assignedCollector?.username || 'Unassigned'}</span>
                                    <span className="flex items-center gap-1"><User className="w-3 h-3" />Task by: {task.author?.username || 'Unknown'}</span>
                                </div>
                            </div>
                            <div className="shrink-0">
                                 <button
                                    onClick={() => onRecordSelect(task.recordId)}
                                    className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded-md transition-colors flex items-center gap-1 justify-center"
                                >
                                    <FileText className="w-3 h-3" />
                                    View Record
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OverdueTasksTab;
